export default __webpack_public_path__ + "static/media/Montserrat-VariableFont.3068cdb4.woff";